<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="clients">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="light-blue darken-4">
                        <v-toolbar-title>Clientes&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewClient"
                            >Nuevo Cliente</v-btn>
                            <v-btn
                                :disabled="(bEdit || clientID === 0 )"
                                text
                                class="text-none"
                                @click="onEditClient"
                            >Editar Cliente</v-btn>
                            <v-btn
                                :disabled="(bEdit || clientID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteClient"
                            >Borrar Cliente</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewClient">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-account-plus</v-icon>&nbsp; Nuevo Administrador
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditClient">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-account-edit</v-icon>&nbsp; Editar Administrador
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteClient">
                                    <v-list-item-title>
                                        <v-icon color="light-blue darken-4">mdi-account-remove</v-icon>&nbsp; Borrar Administrador
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de clientes y cliente seleccionado: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para lista de clientes y card de cliente seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Clientes: *************************** -->
                            <v-flex xs10 sm3>
                                <v-card>
                                    <v-toolbar dense color="light-blue darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Clientes Registrados</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedClientIndex"
                                            color="pink accent-3"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(client, i) in clients"
                                                :key="i"
                                                @click="selectClient(client.clienteid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ client.nombre }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Clientes ********************************* -->

                            <!-- Info del cliente seleccionado: *********************** -->
                            <v-flex xs10 sm9>
                                <v-card class="grey lighten-4" ref="client_card">
                                    <v-toolbar :height="campaignToolbarHeight" color="light-blue lighten-1" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedClientName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-domain</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-domain"
                                                        name="name"
                                                        label="Razón social"
                                                        type="text"
                                                        v-model="name"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                        ref="name_field"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-account-details"
                                                        label="R.F.C."
                                                        type="text"
                                                        v-model="rfc"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-account-tie"
                                                        label="Contacto"
                                                        type="text"
                                                        v-model="contact"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-email"
                                                        name="email"
                                                        label="Correo Electrónico"
                                                        type="email"
                                                        v-model="email"
                                                        :rules="emailRules"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-phone"
                                                        label="Teléfono 1"
                                                        type="text"
                                                        v-model="phone1"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-phone"
                                                        label="Teléfono 2"
                                                        type="text"
                                                        v-model="phone2"
                                                        :readonly="!bEdit"
                                                        color="light-blue darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        v-model="notes"
                                                        :auto-grow="false"
                                                        no-resize
                                                        color="light-blue darken-4"
                                                        label="Notas"
                                                        rows="3"
                                                        :readonly="!bEdit"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>

                                            

                                            

                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de cliente seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de cliente: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingClient" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Cliente</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-3">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al cliente {{ selectedClientName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteClientConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteUser"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de usuario *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="light-blue darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Clientes</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay clientes registrados con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        
                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para indicar que ya existe otro cliente registrado con el mismo nombre: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="duplicatedClientError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Usuario Duplicado</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >Ya existe otro usuario registrado con el mismo correo electrónico.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onDuplicatedUser"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para indicar que ya existe otro usuario registrado con el mismo correo *********************************** -->

                        <!-- Termina renglón único para lista de clientes y cliente seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de clientes y cliente seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'clients',
    data() {
        return {
            drawer: false,
            bMounted: false, //Para saber si ya se puede obtener la altura de los componentes.
            bEdit: false,
            bNew: false,
            campaignToolbarHeight: 48, //48 = dense

            dlgChangePasswd: false,
            bChangePasswd: false,
            bPasswdNotEqual: false,
            bInvalidData: false,
            errorMessage: '',

            clientID: 0,
            name: '',
            rfc: '',
            contact: '',
            phone1: '',
            phone2: '',
            email: '',
            notes: '',
            emailRules: [
                (v) => !!v || 'Introduzca su correo electrónico',
                (v) =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido.',
            ],

            selectedClientName: '',
            bDeletingClient: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
        };
    },
    created() {
        this.selectFirstClient();
        //console.log('clients: ', this.clients);
    },
    mounted() {
        this.bMounted = true;
    },
    
    methods: {
        onClose() {
            this.$router.push('/');
        },


        onNewClient() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedClientName = 'Nuevo Cliente';
            this.selectedClientIndex = -1;

            this.clientID = 0;
            this.name = '';
            this.rfc = '';
            this.contact = '';
            this.email = '';
            this.phone1 = '';
            this.phone2 = '';
            this.notes = '';

            this.$refs.name_field.focus();
        },
        onDeleteClient() {
            this.bDeletingClient = true;
        },
        cancelDeleteUser() {
            this.bDeletingClient = false;
        },
        deleteClientConfirmed() {
            this.bDeletingClient = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.clients.length; i++)
            {
                if (this.clients[i].clienteid === this.clientID)
                {
                    this.clients.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteClient', this.clientID);
            this.selectFirstClient();
        },
        onEditClient() {
           
            this.bEdit = true;
        },
        
        
        onCancel() {
            if (this.bNew)
            {
                this.clientID = 0;
                this.name = '';
                this.rfc = '';
                this.contact = '';
                this.email = '';
                this.phone1 = '';
                this.phone2 = '';
                this.notes = '';

                //Selecciona al primer cliente de la lista:
                this.selectFirstClient();
                this.bNew = false;
            } else {
                
                //Vuelve a obtener los datos originales del usuario seleccionado:
                this.selectClient(this.clientID);
            }
            this.bEdit = false;
        },
        onSave()
        {
            var bDataOK = false;

            //Se validan los datos:
            if (this.name === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'El nombre es obligatorio.';
            }
            else
            if (this.rfc === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'El R.F.C. es obligatorio.';
            }
            else 
            {
                bDataOK = true;
            }
            if (!this.bNew && bDataOK)
            {
                //Edición de cliente...

                const clientInfo = {
                    clienteid: this.clientID,
                    nombre: this.name,
                    rfc: this.rfc,
                    contacto: this.contact,
                    telefono1: this.phone1,
                    telefono2: this.phone2,
                    email: this.email,
                    notas: this.notes,
                };
                console.log('clientInfo = ', clientInfo);

                //Edición del registro en la BD:
                this.$store.dispatch('editClient', clientInfo);

                //Se actualiza el registro local:
                for (let i = 0; i < this.clients.length; i++)
                {
                    if (this.clients[i].clienteid === this.clientID)
                    {
                        this.clients[i].nombre = this.name;
                        this.clients[i].rfc = this.rfc;
                        this.clients[i].contacto = this.contact;
                        this.clients[i].telefono1 = this.phone1;
                        this.clients[i].telefono2 = this.phone2;
                        this.clients[i].email = this.email;
                        this.clients[i].notas = this.notes;

                        break;
                    }
                }
            } //end edición de cliente.
            else if (this.bNew && bDataOK)
            {
                //Registro de nuevo cliente...
                
                this.bNew = false;

                const newClient = {
                    clienteid: this.clientID,
                    nombre: this.name,
                    rfc: this.rfc,
                    contacto: this.contact,
                    telefono1: this.phone1,
                    telefono2: this.phone2,
                    email: this.email,
                    notas: this.notes,
                };

                this.$store.dispatch('saveNewClient', newClient);
            } //end registro de nuevo usuario.

            if (bDataOK)
            {
                this.selectedClientName = this.lastName1 + ' ' + this.lastName2 + ' ' + this.name;
                this.bEdit = false;
            }
        },
        selectFirstClient()
        {
            if (this.clients.length > 0)
            {
                this.selectedClientIndex = 0;
                var clientID = this.clients[this.selectedClientIndex].clienteid;
                this.selectClient(clientID);
            }
            else
            {
                this.selectedClientIndex = -1;
                this.clientID = 0;
            }
        },
        selectClient(clientID)
        {
            var i;
            for (i = 0; i < this.clients.length; i++)
            {
                if (this.clients[i].clienteid === clientID)
                {
                    console.log("Cliente seleccionado: ", this.clients[i]);
                    this.clientID = clientID;

                    this.name = this.clients[i].nombre;
                    this.rfc = this.clients[i].rfc;
                    this.contact = this.clients[i].contacto;
                    this.email = this.clients[i].email;
                    this.phone1 = this.clients[i].telefono1;
                    this.phone2 = this.clients[i].telefono2;
                    this.notes = this.clients[i].notas;

                    this.selectedClientName = this.name;


                    break;
                }
            }
        },
        onSearch()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.clients.length; i++)
                {
                    var strLowerCaseText = this.clients[i].nombre.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedClientIndex = i;
                        this.selectClient(this.clients[i].clienteid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        onDuplicatedUser()
        {
            this.duplicatedClientError = false;
            this.selectedClientName = 'Nuevo Cliente';
            this.bEdit = true;
            this.bNew = true;
        },
    },
    computed:
    {
        ...mapGetters([
            'clients',
            'waitCursor',
            'userTypes'
        ]),
        selectedClientIndex:
        {
            get() {
                return this.$store.getters.selectedClientIndex;
            },
            set(selectedClientIndex) {
                this.$store.dispatch('updateSelectedClientIndex', selectedClientIndex);
            },
        },
        
        duplicatedClientError:
        {
            get() {
                return this.$store.getters.duplicatedClientError;
            },
            set(duplicatedClientError) {
                this.$store.dispatch('setduplicatedClientError', duplicatedClientError);
            },
        },

        // style="height: 578px; max-height:100%"
        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            }
            else
            if (this.bMounted)
            {
                height = this.$refs.client_card.$el.clientHeight - this.campaignToolbarHeight + 'px';
                //height = this.$refs.client_card.$el.clientHeight + 'px';
            }
            else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '40';
            } else if (this.$vuetify.breakpoint.md) {
                height = '50';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '60';
            } else {
                height = '80';
            }
            return height;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.clients {
    background: url('../assets/fondo2.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>